export const commonColors = {
  grayDark: '#697A8B',
};
